import React from 'react';
import { CardForm } from '../Card';
import "./index.css"
function App() {
  return (
    <div className='app'>
      
      <CardForm/>
    </div>
    
  );
}

export {App};
